export default {
    "searchjoborcompany": "İş veya Firma Ara",
    "searchcitycounty": "İl,İlçe Ara",
    "choosesector": "Sektör Seç",
}
